import React from "react";
import "./BackGround.css";
import BGCanvas from "./BGCanvas";

interface BackGroundProps{
    currentSection:number;
}

const BackGround:React.FC<BackGroundProps> = (props) => {
    return(
        <div className={"BackGroundBase" + (props.currentSection == 4 ? " Dark":"")}>
            <BGCanvas currentSection={props.currentSection}/>
        </div>
    )
}
export default BackGround;